import React from 'react';

import { Container } from './styles';

const Empty: React.FC = ({ children }) => {
  return (
    <Container>
      <>{children}</>
    </Container>
  );
};

export default Empty;
